module.exports = __webpack_public_path__ + "static/media/blue_night_short.6f4f8bba.svg";